<template lang="pug">
#login-view
  #login-view-container
    .login
      img.logo(src="@/assets/logo_original_samtek.png")
      router-view(v-if="$route.meta.ownCard")
      .card-login(v-else)
        router-view
    Footer
</template>

<script>
import Footer from '@/components/UI/Footer.vue';
import Login from '../components/auth/Login.vue'

export default {
  components: {
    Login,
    Footer,
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/global.scss';
@import '@/style/colors.scss';

#login-view {
  padding: 1rem;
  height: 100%;
  background-image: url(/fondo_samtek.png);
  background-color: #F5F6FA;
  background-size: contain;
  &-container {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
.login {
  width: 100%;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .logo {
    /* margin: -20px auto 40px; */
    padding-bottom: 3rem;
    margin-top: 3rem;
    width: 329px;
    max-width: 80%;
  }
  .card-login {
    background: #f1f5f8 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 5px;
    opacity: 1;
    padding: 35px 45px;
    width: 430px;
    height: 480px;
    @media (max-width: 768px) {
      width: 100%;
    }
    @media (width: 768px) {
      width: 430px;
      height: 480px;
      margin-left: -100px;
    }
    @media (width: 1024px) {
      width: 430px;
      height: 480px;
      margin-left: -55px;
    }
  }
}
</style>

<style lang="scss">
@import '@/style/colors.scss';

#login-view {
  .subtitle {
    color: #7f828f;
    text-align: center;
    font-size: 14px;
    margin-bottom: 40px;
    h4 {
      color: $samtek-black;
      font-size: 18px;
      font-weight: bold;
      margin: 15px 0;
    }
    p {
      margin: 5px 0;
      line-height: 120%;
    }
  }
  .icon-container {
    position: absolute;
    margin-left: 15px;
    height: 50px;
    display: flex;
    align-items: center;
  }
  input {
    padding-left: 35px;
    height: 50px;
  }
  .boton {
    margin: 20px 0;
    font-size: 15px;
    font-weight: 500;
    span {
      margin-left: 5px;
    }
  }
}
</style>
